export default __webpack_public_path__ + "static/hero-67acc0710e28639817bbeb16d7c29a68.jpeg";